<template>
<div class="chapter">
<div class="inner_page">
<div class="tp">
<h1 class="title"><strong>DAVID CESARANI</strong></h1>
<h1 class="title1"><strong>FINAL SOLUTION</strong></h1>
<p class="title2"><strong>THE FATE OF THE JEWS 1933–1949</strong></p>
<p class="center">St. Martin’s Press<br/>New York</p>
<p class="center"><img alt="" src="OEBPS/images/logo2.png"/></p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// tp.vue?4a472403